import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeDateToGivenFormat, getCurrentDate } from '../../../../../../../Utils/DateUtils';
import { AppConstant } from '../../../../../../Assests/AppConstant';
import { getUserSelector } from '../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { sagaActions } from '../../../../../../../sagas/sagaActions';
import { fetchDockListCommonFunc } from '../DocksMeta/Common/FetchDockList';
import { showAlert, changeFormatWithoutTz } from '../../../../../../Assests/Utility';
import { toast } from 'react-toastify';
import _ from 'lodash-es';
import { fetchLeavesListCommonFunc, fetchLeavesDocksListCommonFunc } from './Common/FetchLeavesList';
import { getWhMetaDataReducerSlice } from '../../../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice';
import './LeavesMetaDataForm.css';
import WarehouseSearchSS from '../../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearchSS';
import LeavesMetaListSS from './LeavesMetaList/LeavesMetaListSS';
import SSPopup from '../../../../../Common/Popup/SSPopup/SSPopup';
import CustomDropDownSS from '../../../../../Common/CustomDropDown/CustomDropDownSS';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import AutomaticCancelPopup from '../Common/AutomaticCancelPopup';

// today in YYYY-MM-DD for native date input min attribute
const todayStr = moment().format('YYYY-MM-DD');

/**
 * Validates a YYYY-MM-DD string coming from a native <input type="date">.
 * @param {string} dateStr   - e.target.value ('' when invalid/incomplete)
 * @param {boolean} badInput - e.target.validity.badInput
 * @param {'start'|'end'} fieldRole - for past-date check context
 * @param {string|null} minDateStr  - YYYY-MM-DD; dateStr must be >= minDateStr when provided
 * @returns {string} error message or '' when valid
 */
const validateDateInput = (dateStr, badInput, fieldRole, minDateStr) => {
    // User typed something but browser couldn't form a valid date
    // (covers invalid days like Feb 31, 6-digit year, etc.)
    if (badInput && !dateStr) {
        return 'Please enter a valid date (MM/DD/YYYY)';
    }

    if (!dateStr) return '';

    // Check the year part has exactly 4 digits (rejects 6-digit years)
    const parts = dateStr.split('-');
    if (parts.length === 3) {
        const year = parts[0];
        if (year.length !== 4 || parseInt(year, 10) < 1000 || parseInt(year, 10) > 9999) {
            return 'Year must be a valid 4-digit year (e.g. 2025)';
        }

        // Validate calendar correctness: e.g. Feb 31 is invalid
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);
        const dateObj = new Date(`${dateStr}T00:00:00`);
        if (
            isNaN(dateObj.getTime()) ||
            dateObj.getMonth() + 1 !== month ||
            dateObj.getDate() !== day
        ) {
            return `Invalid date: ${parts[1]}/${parts[2]}/${year} does not exist`;
        }
    }

    // Past-date check for start date
    if (fieldRole === 'start' && minDateStr && dateStr < minDateStr) {
        return 'Leave Start Date cannot be a past date';
    }

    return '';
};

const initialFormState = {
    LeaveStart: '',
    LeaveEnd: '',
    IDDock: '',
    Purpose: '',
    leavesForWhOrDock: 'Docks',
};

const initialErrors = {
    LeaveStart: '',
    LeaveEnd: '',
    IDDock: '',
    Purpose: '',
};

const initialDirty = {
    LeaveStart: false,
    LeaveEnd: false,
    IDDock: false,
    Purpose: false,
};

const LeavesMetaDataFormSS = (props) => {

    const { themeSelected, allowPermissionD, whObj } = props;
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [searchStr, setSearchStr] = useState('');
    const [editData, setEditData] = useState({});
    const [loading, setLoading] = useState(false);
    const [formInputs, setFormInputs] = useState(initialFormState);
    const [errors, setErrors] = useState(initialErrors);
  const [dirty, setDirty] = useState(initialDirty);
    const [dateResetKey, setDateResetKey] = useState(0);
    const [isDockHidden, setIsDockHidden] = useState(false);
    const [currentFilterSelected, setCurrentFilterSelected] = useState({ name: 'Docks' });
    const [showPreCheckModal, setShowPreCheckModal] = useState(false);
    const [showAutomaticCancelConfirmPopup, setShowAutomaticCancelConfirmPopup] = useState(false);
    const [pendingLeaveData, setPendingLeaveData] = useState(null);
    const [showAutoMassCancelNotification, setShowAutoMassCancelNotification] = useState(false);
    const navigate = useNavigate();
    const firstUpdate = useRef(true);

    const user = useSelector(getUserSelector);
    const { cu_id } = user;
    const whMetaData = useSelector(getWhMetaDataReducerSlice);
    const { whMetaDocksList, operationObj, preCheckList } = whMetaData;

    useEffect(() => {
        setLoading(false);
        setShowModal(false);
        setEditData({});
        fetchDockList();
        setShowAutoMassCancelNotification(false);
        dispatch({ type: sagaActions.UPDATE_PRE_CHECK_LIST, payload: [] });
    }, []);

    useEffect(() => {
        return () => {
            dispatch({ type: sagaActions.RESET_MASS_CANCEL_REASON });
        };
    }, []);

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        if (preCheckList.length > 0) {
            setShowModal(false);
            setLoading(false);
            const selectedDockId = pendingLeaveData?.apiParams?.IDDock;
            const selectedDock = whMetaDocksList.find(dock => dock.ID === selectedDockId);
            if (selectedDock?.AppointmentCancelationType === 'AUTOMATIC') {
                setShowAutomaticCancelConfirmPopup(true);
            } else {
                setShowPreCheckModal(true);
            }
        }
    }, [preCheckList]);

    useEffect(() => {
        if (operationObj.type) {
            switch (operationObj.type) {
                case 'Add Leave':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.leaves.createLeaveSuccess, showAutoMassCancelNotification);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.leaves.createLeaveFailure, showAutoMassCancelNotification);
                    }
                    break;
                case 'Edit Leave':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.leaves.updateLeaveSuccess, showAutoMassCancelNotification);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.leaves.updateLeaveFailure, showAutoMassCancelNotification);
                    }
                    break;
                case 'Update status':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.smartScheduler.leaves.updateLeaveStatusSuccess, showAutoMassCancelNotification);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.smartScheduler.leaves.updateLeaveStatusFailure, showAutoMassCancelNotification);
                    }
                    break;
                default:
            }
        }
    }, [operationObj]);

    const handleApiResponse = (result, message, showAutoMassCancelNotification) => {
        if (result === AppConstant.notifications.dataAddedSuccess) {
            showAlert(toast.TYPE.SUCCESS, message, themeSelected);
            setShowModal(false);
            fetchLeavesList();
            if (showAutoMassCancelNotification) {
                showAlert(toast.TYPE.INFO, AppConstant.smartScheduler.leaves.massCancellationNotification, themeSelected);
                setShowAutoMassCancelNotification(false);
            }
        } else {
            showAlert(toast.TYPE.ERROR, message, themeSelected);
        }
        setLoading(false);
        dispatch({ type: sagaActions.RESET_SS_PO_OPERATION_OBJ });
    };

    const fetchDockList = () => {
        const { apiParams, operationObj } = fetchDockListCommonFunc(whObj);
        dispatch({ type: sagaActions.WAREHOUSE_META_DOCK_LIST_ACTION, payload: apiParams, operationObj: operationObj });
    };

    const fetchLeavesList = () => {
        if (currentFilterSelected.name === 'Warehouse') {
            const { apiParams, operationObj } = fetchLeavesListCommonFunc(whObj);
            dispatch({ type: sagaActions.WAREHOUSE_META_LEAVES_LIST_ACTION, payload: apiParams, operationObj: operationObj });
        } else {
            fetchDocksList();
        }
    };

    const fetchDocksList = () => {
        const { apiParams, operationObj } = fetchLeavesDocksListCommonFunc(whObj);
        dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_LEAVES_LIST_ACTION, payload: apiParams, operationObj: operationObj });
    };

  const resetForm = () => {
        setFormInputs(initialFormState);
        setErrors(initialErrors);
  setDirty(initialDirty);
        setEditData({});
        setDateResetKey((k) => k + 1);
    };

    const getDockList = () => {
        const docksList = whMetaDocksList && whMetaDocksList.length && whMetaDocksList.map((ele) => {
            if (ele && ele.DockStatus) {
                const operationalDays = {
                    sunday: ele.sunday,
                    monday: ele.monday,
                    tuesday: ele.tuesday,
                    wednesday: ele.wednesday,
                    thursday: ele.thursday,
                    friday: ele.friday,
                    saturday: ele.saturday
                };
                const dayAbbreviations = {
                    sunday: 'Sun', monday: 'Mon', tuesday: 'Tue',
                    wednesday: 'Wed', thursday: 'Thu', friday: 'Fri', saturday: 'Sat'
                };
                const activeDays = Object.keys(operationalDays)
                    .filter(day => operationalDays[day])
                    .map(day => dayAbbreviations[day]);
                const daysDisplay = activeDays.length > 0 ? activeDays.join(', ') : 'Non Operational';
                return (
                    <option key={ele.Name} value={ele.ID}>
                        {ele.Name} ({daysDisplay})
                    </option>
                );
            }
            return null;
        });
        return _.compact(docksList);
    };

    /**
   * Validates all form fields and returns true if valid.
   * Populates errors state.
 */
    const validate = () => {
        let valid = true;
        const errorData = { ...initialErrors };

        // Validate Leave Start Date
        if (!formInputs.LeaveStart) {
            errorData.LeaveStart = errors.LeaveStart || AppConstant.help.required;
            valid = false;
        } else {
            const startErr = validateDateInput(formInputs.LeaveStart, false, 'start', todayStr);
            if (startErr) {
                errorData.LeaveStart = startErr;
                valid = false;
            }
        }

        // Validate Leave End Date
        if (!formInputs.LeaveEnd) {
            errorData.LeaveEnd = errors.LeaveEnd || AppConstant.help.required;
            valid = false;
        } else {
            const endErr = validateDateInput(formInputs.LeaveEnd, false, 'end', null);
            if (endErr) {
                errorData.LeaveEnd = endErr;
                valid = false;
            }
        }

        // Cross-field: end >= start
        if (formInputs.LeaveStart && formInputs.LeaveEnd && !errorData.LeaveStart && !errorData.LeaveEnd) {
            if (formInputs.LeaveEnd < formInputs.LeaveStart) {
                errorData.LeaveEnd = 'End date must be on or after start date';
                valid = false;
            }
        }

        // Dock required (when not hidden)
        if (!isDockHidden && !formInputs.IDDock) {
            errorData.IDDock = AppConstant.help.required;
            valid = false;
        }

        // Purpose required
        if (!formInputs.Purpose || !formInputs.Purpose.trim()) {
            errorData.Purpose = AppConstant.help.required;
            valid = false;
        }

        setErrors(errorData);
        return valid;
    };

    const handleChange = (data, name, validity) => {
        if (name === 'leavesForWhOrDock') {
            if (data === 'Warehouse') {
                setIsDockHidden(false);
            } else {
                setIsDockHidden(true);
            }
            setFormInputs(prev => ({ ...prev, leavesForWhOrDock: data }));
            return;
        }

        if (name === 'LeaveStart') {
            const newStartStr = data;
            const badInput = validity ? validity.badInput : false;
            const err = validateDateInput(newStartStr, badInput, 'start', todayStr);
            if (err) {
                setErrors(prev => ({ ...prev, LeaveStart: err }));
                setDirty(prev => ({ ...prev, LeaveStart: true }));
                setFormInputs(prev => ({ ...prev, LeaveStart: newStartStr }));
                return;
            }
            // Clear end date if it would become before new start
            if (formInputs.LeaveEnd && newStartStr && formInputs.LeaveEnd < newStartStr) {
                setFormInputs(prev => ({ ...prev, LeaveStart: newStartStr, LeaveEnd: '' }));
            } else {
                setFormInputs(prev => ({ ...prev, LeaveStart: newStartStr }));
            }
            setErrors(prev => ({ ...prev, LeaveStart: '', LeaveEnd: '' }));
            return;
        }

        if (name === 'LeaveEnd') {
            const newEndStr = data;
            const badInput = validity ? validity.badInput : false;
            const err = validateDateInput(newEndStr, badInput, 'end', null);
            if (err) {
                setErrors(prev => ({ ...prev, LeaveEnd: err }));
                setDirty(prev => ({ ...prev, LeaveEnd: true }));
                setFormInputs(prev => ({ ...prev, LeaveEnd: newEndStr }));
                return;
            }
            if (formInputs.LeaveStart && newEndStr && newEndStr < formInputs.LeaveStart) {
                setErrors(prev => ({ ...prev, LeaveEnd: 'End date must be on or after start date' }));
                setFormInputs(prev => ({ ...prev, LeaveEnd: newEndStr }));
                return;
            }
            setFormInputs(prev => ({ ...prev, LeaveEnd: newEndStr }));
            setErrors(prev => ({ ...prev, LeaveEnd: '' }));
            return;
        }

        setFormInputs(prev => ({ ...prev, [name]: data }));
    };

    const handleBlur = (name, validity) => {
        setDirty(prev => ({ ...prev, [name]: true }));

        if (name === 'LeaveStart' || name === 'LeaveEnd') {
            const currentVal = formInputs[name] || '';
            const badInput = validity ? validity.badInput : false;
            const fieldRole = name === 'LeaveStart' ? 'start' : 'end';
            const minDate = name === 'LeaveStart' ? todayStr : null;
            const err = validateDateInput(currentVal, badInput, fieldRole, minDate);
            if (err) {
                setErrors(prev => ({ ...prev, [name]: err }));
                return;
            }
            if (name === 'LeaveEnd' && formInputs.LeaveStart && currentVal && currentVal < formInputs.LeaveStart) {
                setErrors(prev => ({ ...prev, LeaveEnd: 'End date must be on or after start date' }));
                return;
            }
            setErrors(prev => ({ ...prev, [name]: '' }));
            return;
        }

        // Generic required check on blur
        if (!formInputs[name] || (typeof formInputs[name] === 'string' && !formInputs[name].trim())) {
            setErrors(prev => ({ ...prev, [name]: AppConstant.help.required }));
        } else {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const submitForm = () => {
        setDirty({ LeaveStart: true, LeaveEnd: true, IDDock: true, Purpose: true });
        if (validate()) {
            getSummitedFormData(formInputs);
        }
    };

    const createPayload = (data, type) => {
        if (type === 'Edit') {
            return {
                IDDockLeave: data.leavesForWhOrDock === 'Docks' ? data.IDDockLeave : null,
                IDWHLeave: data.leavesForWhOrDock === 'Warehouse' ? data.IDWHLeave : null,
                IDWarehouse: data.IDWarehouse,
                Purpose: data.Purpose,
                LeaveStart: data.LeaveStart,
                LeaveEnd: data.LeaveEnd,
                Status: 1,
                CRUDTYPE: 'U',
                Description: data.Purpose,
                IDDock: data.leavesForWhOrDock === 'Docks' ? data.IDDock : data.IDWHLeave,
                UpdatedBy: cu_id,
                UpdatedOn: changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                AppointmentCancelationType: 'MANUAL',
                ConflictAptStatus: false
            };
        } else {
            return {
                IDDockLeave: null,
                IDWarehouse: whObj.ID,
                IDWHLeave: null,
                Description: data.Purpose,
                Purpose: data.Purpose,
                LeaveStart: data.LeaveStart,
                LeaveEnd: data.LeaveEnd,
                Status: 1,
                UpdatedBy: cu_id,
                CRUDTYPE: 'I',
                IDDock: data.leavesForWhOrDock === 'Docks' ? data.IDDock : null,
                CreatedOn: changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                CreatedBy: cu_id,
                UpdatedOn: changeFormatWithoutTz(getCurrentDate(), AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                AppointmentCancelationType: 'MANUAL',
                ConflictAptStatus: false
            };
        }
    };

    const getSummitedFormData = (data) => {
        setLoading(true);
        let apiParams = {};
        const operationObj = { type: '', status: '' };

        if (Object.keys(editData).length) {
            const apiTempParams = createPayload(data, 'Edit');
            operationObj.type = 'Edit Leave';
            apiParams = { ...data, ...apiTempParams };
        } else {
            apiParams = createPayload(data, 'Create');
            operationObj.type = 'Add Leave';
        }

        setPendingLeaveData({ apiParams, operationObj, leavesForWhOrDock: data.leavesForWhOrDock });

        if (data.leavesForWhOrDock === 'Warehouse') {
            dispatch({ type: sagaActions.WAREHOUSE_META_LEAVES_LIST_ACTION, payload: apiParams, operationObj: operationObj });
        } else {
            dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_LEAVES_LIST_ACTION, payload: apiParams, operationObj: operationObj });
        }
    };

    const createForm = () => {
        const isEdit = Object.keys(editData).length > 0;
        return (
            <div className="container-fluid py-2">
                <div className="row gy-2">

                    {/* Break Type — only show in create mode (edit keeps same type) */}
                    {!isEdit && (
                        <div className="col-sm-12 mt-2 hidden">
                            <label className="form-label">Select for:</label>
                            <div className="radioButtonText d-flex form-check form-check-inline gap-5">
                                <label className="form-check-label">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        name="leavesForWhOrDock"
                                        value="Docks"
                                        checked={formInputs.leavesForWhOrDock === 'Docks'}
                                        onChange={(e) => handleChange(e.target.value, 'leavesForWhOrDock')}
                                    />
                                    Docks
                                </label>
                            </div>
                        </div>
                    )}

                    {/* Dock selection */}
                    {!isDockHidden && (
                        <div className="col-sm-12">
                            <label className="form-label">
                                Dock<span className="color-red">*</span>
                            </label>
                            <select
                                className={`customSelect ${dirty.IDDock && errors.IDDock ? 'is-invalid' : ''}`}
                                value={formInputs.IDDock || ''}
                                onChange={(e) => handleChange(e.target.value, 'IDDock')}
                                onBlur={() => handleBlur('IDDock')}
                                disabled={isEdit}
                            >
                                <option value="">Select Dock</option>
                                {getDockList()}
                            </select>
                            {dirty.IDDock && errors.IDDock && (
                                <span className="errorMessage d-block">{errors.IDDock}</span>
                            )}
                        </div>
                    )}

                    {/* Leave Start Date — native date input with strict validation */}
                    <div className="col-sm-6 mt-1">
                        <label className="form-label">
                            {AppConstant.reports.adfatReport.dropdownLabels.startDate}
                            <span className="color-red">*</span>
                        </label>
                         <input
                      key={`LeaveStart-${dateResetKey}`}
                              type="date"
                              className={`customTextInput w-100 ${dirty.LeaveStart && errors.LeaveStart ? 'customError' : ''}`}
                  value={formInputs.LeaveStart || ''}
                         min={todayStr}
                   max="9999-12-31"
                       onChange={(e) => handleChange(e.target.value, 'LeaveStart', e.target.validity)}
                                onBlur={(e) => handleBlur('LeaveStart', e.target.validity)}
                    />
                        {dirty.LeaveStart && errors.LeaveStart && (
                            <span className="errorMessage d-block">{errors.LeaveStart}</span>
                        )}
                    </div>

                    {/* Leave End Date — native date input with strict validation */}
                    <div className="col-sm-6 mt-1">
                        <label className="form-label">
                            {AppConstant.reports.adfatReport.dropdownLabels.endDate}
                            <span className="color-red">*</span>
                        </label>
             <input
             key={`LeaveEnd-${dateResetKey}`}
                 type="date"
                className={`customTextInput w-100 ${dirty.LeaveEnd && errors.LeaveEnd ? 'customError' : ''}`}
        value={formInputs.LeaveEnd || ''}
            min={formInputs.LeaveStart || todayStr}
                  max="9999-12-31"
     onChange={(e) => handleChange(e.target.value, 'LeaveEnd', e.target.validity)}
         onBlur={(e) => handleBlur('LeaveEnd', e.target.validity)}
             />
                        {dirty.LeaveEnd && errors.LeaveEnd && (
                            <span className="errorMessage d-block">{errors.LeaveEnd}</span>
                        )}
                    </div>

                    {/* Description / Purpose */}
                    <div className="col-sm-12">
                        <label className="form-label">
                            Description<span className="color-red">*</span>
                        </label>
                        <textarea
                            className={`form-control ${dirty.Purpose && errors.Purpose ? 'is-invalid' : ''}`}
                            value={formInputs.Purpose || ''}
                            onChange={(e) => handleChange(e.target.value, 'Purpose')}
                            onBlur={() => handleBlur('Purpose')}
                            rows="3"
                        />
                        {dirty.Purpose && errors.Purpose && (
                            <span className="errorMessage d-block">{errors.Purpose}</span>
                        )}
                    </div>
                </div>

                {/* Form Buttons */}
                <div className="d-flex justify-content-end marbt-10 mt-3 gap-2">
                    <button
                        type="button"
                        className="btn-unstyled light-mode"
                        onClick={resetForm}
                        disabled={loading}
                    >
                        {AppConstant.comments.resetbutton}
                    </button>
                    <button
                        type="button"
                        className="btn-styled light-mode"
                        onClick={submitForm}
                        disabled={loading}
                    >
                        {loading ? (
                            <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> Loading...</>
                        ) : (
                            AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle
                        )}
                    </button>
                </div>
            </div>
        );
    };

    const editLeave = (data) => {
        const leaveType = data.IDDock ? 'Docks' : 'Warehouse';
        const editData1 = {
            IDWHLeave: data.IDWHLeave,
            ID: data.ID,
            Purpose: data.Purpose || data.Description,
            // Convert ISO date strings to YYYY-MM-DD for native date inputs
            LeaveStart: data.LeaveStart ? moment(data.LeaveStart).utc().format('YYYY-MM-DD') : '',
            LeaveEnd: data.LeaveEnd ? moment(data.LeaveEnd).utc().format('YYYY-MM-DD') : '',
            Status: data.Status,
            CreatedOn: data.CreatedOn || null,
            CreatedBy: cu_id,
            UpdatedOn: data.UpdatedOn,
            UpdatedBy: data.UpdatedBy,
            IDWarehouse: data.IDWarehouse,
            IDDockLeave: data.IDDockLeave,
            IDDock: data.IDDock,
            leavesForWhOrDock: leaveType,
        };

        if (leaveType === 'Docks') {
            setIsDockHidden(true);
        } else {
            setIsDockHidden(false);
        }

        setShowModal(true);
        setEditData(editData1);
        setFormInputs(editData1);
        setErrors(initialErrors);
        setDirty(initialDirty);
    };

    const closeCurrentpopup = () => {
        setEditData({});
        setFormInputs(initialFormState);
        setErrors(initialErrors);
        setDirty(initialDirty);
        setShowModal(false);
    };

    const showCreateLeavePopup = () => {
        const popupObj = {
            id: 'createCompanyGroupFormPopup1',
            modalLabel: 'createCompanyGroupFormPopup1',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: !Object.keys(editData).length
                ? AppConstant.smartScheduler.leaves.addLeaveTitle
                : AppConstant.smartScheduler.leaves.editLeaveTitle,
            bodyText: createForm(),
            subText: '',
            keyboard: false,
            backdrop: 'static',
            footerBtn: {
                btn1: { show: true, text: AppConstant.comments.cancelCommentButtonTitle },
                btn2: { show: true, text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle }
            },
        };
        return <SSPopup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={closeCurrentpopup} themeSelected={themeSelected} showModal={showModal} />;
    };

    const openCreateForm = () => {
        setEditData({});
        setFormInputs(initialFormState);
        setErrors(initialErrors);
        setDirty(initialDirty);
        setIsDockHidden(false);
        setShowModal(true);
    };

    const showCustomDropDownForFilters = () => {
        const filterDataArr = [{ name: 'Warehouse' }, { name: 'Docks' }];
        return (
            <div className='d-flex align-items-center'>
                <CustomDropDownSS themeSelected={themeSelected} data={filterDataArr} placeHolder={currentFilterSelected.name} onSelect={(event) => setCurrentFilterSelected(event)} keyStr={'name'} />
            </div>
        );
    };

    const closePreCheckpopup = () => {
        setShowPreCheckModal(false);
    };

    const popupBtnHandler = (text) => {
        if (text === AppConstant.commonStrings.viewDetailsStr) {
            navigate('/manageappointments');
        } else {
            setShowPreCheckModal(false);
        }
    };

    const handleDisableLeaveWithPreCheck = (apiParams, operationObj) => {
        setPendingLeaveData({ apiParams, operationObj, leavesForWhOrDock: 'Docks' });
        dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_LEAVES_LIST_ACTION, payload: apiParams, operationObj: operationObj });
    };

    const showPreCheck = () => {
        const popupObj = {
            id: 'adminUpdateOperationPreCheck',
            modalLabel: 'adminUpdateOperationPreCheck',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: AppConstant.smartScheduler.leaves.apptConflict,
            bodyText: AppConstant.superUserAdmin.warehouseAdmin.preCheckBockerMsg,
            subText: '',
            keyboard: false,
            backdrop: 'static',
            footerBtn: {
                btn1: { show: true, text: AppConstant.commonStrings.viewDetailsStr },
                btn2: { show: false }
            },
        };
        return <SSPopup {...popupObj} popupBtnHandler={(text) => popupBtnHandler(text)} closepopup={() => { closePreCheckpopup(); }} themeSelected={themeSelected} showModal={showPreCheckModal} />;
    };

    const handleAutomaticCancelConfirm = (selectedReason, excludedAppointments) => {
        setLoading(true);
        const { apiParams, operationObj, leavesForWhOrDock } = pendingLeaveData;
        // If selectedReason is null, all appointments were excluded - skip cancellation, still save the leave
        const allExcluded = !selectedReason;
        const newApiParams = {
            ...apiParams,
            ConflictAptStatus: !allExcluded,
            AppointmentCancelationType: allExcluded ? null : 'AUTOMATIC',
            Reason: allExcluded ? null : selectedReason,
            ExcludedAppointments: !allExcluded && excludedAppointments && excludedAppointments.length ? excludedAppointments.toString() : null
        };
        // When all appointments are excluded, mark confirm=true so the saga skips the pre-check
        // and proceeds directly to saving the leave (avoids re-triggering showPreCheckModal).
        const newOperationObj = allExcluded ? { ...operationObj, confirm: true } : operationObj;
        dispatch({ type: sagaActions.UPDATE_PRE_CHECK_LIST, payload: [] });

        if (leavesForWhOrDock === 'Warehouse') {
            dispatch({ type: sagaActions.WAREHOUSE_META_LEAVES_LIST_ACTION, payload: newApiParams, operationObj: newOperationObj });
        } else {
            dispatch({ type: sagaActions.WAREHOUSE_META_DOCKS_LEAVES_LIST_ACTION, payload: newApiParams, operationObj: newOperationObj });
        }
        if (!allExcluded) {
            setShowAutoMassCancelNotification(true);
        }
        setPendingLeaveData(null);
    };

    const showAutomaticCancelPopup = () => {
        if (!showAutomaticCancelConfirmPopup) return null;

        const popupBodyText = `You have created a facility closure from ${moment(pendingLeaveData?.apiParams?.LeaveStart).tz(moment.tz.guess()).format('MM/DD/YYYY')} to ${moment(pendingLeaveData?.apiParams?.LeaveEnd).tz(moment.tz.guess()).format('MM/DD/YYYY')}. There ${_.uniqBy(preCheckList, 'PORelationID').length === 1 ? 'is ' : 'are '} ${_.uniqBy(preCheckList, 'PORelationID').length} appointments already scheduled for the following time slot(s):`;

        return (
            <AutomaticCancelPopup
                themeSelected={themeSelected}
                showPopup={showAutomaticCancelConfirmPopup}
                setShowPopup={setShowAutomaticCancelConfirmPopup}
                pendingData={pendingLeaveData}
                setPendingData={setPendingLeaveData}
                whObj={whObj}
                onProceed={handleAutomaticCancelConfirm}
                popupTitle="Confirm Facility Closure"
                popupBodyText={popupBodyText}
                cuid={cu_id}
                showCheckboxes={true}
            />
        );
    };

    return (
        <div>
            <div className='container-fluid d-flex py-2 text-start justify-content-between mt-1'>
                <button
                    className={'btn-highlighted f-12'}
                    data-bs-toggle="modal"
                    onClick={() => openCreateForm()}
                >
                    {AppConstant.smartScheduler.leaves.addLeaveTitle}
                </button>
                <div className='d-flex w-50 justify-content-end'>
                    <div className='ms-5'>
                        <WarehouseSearchSS
                            placeholder={'Search Facility Closures'}
                            inputValue={searchStr}
                            cancelSearch={() => setSearchStr('')}
                            onChangeHandler={(text) => setSearchStr(text)} />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-center metaLeavesList">
                <LeavesMetaListSS
                    currentFilterSelected={currentFilterSelected}
                    whObj={whObj}
                    {...props}
                    allowPermissionE={true}
                    searchStr={searchStr}
                    editLeaveAction={(groupObj) => editLeave(groupObj)}
                    showPopup={() => showCreateLeavePopup()}
                    themeSelected={themeSelected}
                    allowPermissionD={allowPermissionD}
                    whMetaDocksList={whMetaDocksList}
                    handleDisableLeaveWithPreCheck={handleDisableLeaveWithPreCheck}
                />
                {showCreateLeavePopup()}
                {showPreCheck()}
                {showAutomaticCancelPopup()}
            </div>
        </div>
    );
};

export default LeavesMetaDataFormSS;
